var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":require('@/graphql/JobPost.gql'),"variables":{ id: _vm.$route.params.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',{staticClass:"loading apollo"},[_vm._v("Loading...")]):(error)?_c('div',{staticClass:"error apollo"},[_vm._v("An error occured")]):(data)?_c('div',{staticClass:"result apollo"},[_c('v-container',[_c('CandidateReview',{attrs:{"jobPost":data.jobPost}})],1)],1):_c('div',{staticClass:"no-result apollo"})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }